<div class="header-bar">
  <div class="flex">
    <div class="flex-grow-1">
      <h1>Manage Non-Movement Description</h1>
    </div>
    <div class="flex-shrink-1 pt-2">
      <button
        pButton
        type="button"
        label="Create"
        p-icon="fa fa-plus"
        class="ui-button ui-button-success"
        (click)="showDescriptionFormDialog()"
      ></button>
    </div>
  </div>
</div>
<div class="">
  <div class="content-container" style="position: relative">
    <div *ngIf="nonMovementDescriptions?.length">
      <div>
        <p-table [value]="nonMovementDescriptions">
          <ng-template pTemplate="header">
            <tr>
              <th class="">Description</th>
              <th class="">Xero Code</th>
              <th class="">Logic</th>
              <th class="">Is Debit</th>
              <th class="">Include VAT</th>
              <th style="width: 6em"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
            <tr>
              <td styleClass="">
                <div class="">{{ rowData.description }}</div>
              </td>
              <td class="text-center">
                <div class="">{{ rowData.xeroCode }}</div>
              </td>
              <td class="text-center">
                <div class="">{{ rowData.logic }}</div>
              </td>
              <td class="text-center">
                <span [ngClass]="rowData.isDebit ? 'pi pi-check' : 'pi pi-times'"></span>
              </td>
              <td class="text-center">
                <span [ngClass]="rowData.includeVAT ? 'pi pi-check' : 'pi pi-times'"></span>
              </td>
              <td class="">
                <div class="ui-g-6">
                  <span class="fa fa-pencil link" (click)="modifyDescription(rowData)"></span>
                </div>
                <div class="ui-g-6">
                  <span
                    class="fa fa-trash link text-danger"
                    (click)="deleteDescription(rowData)"
                  ></span>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <p-confirmDialog
      header="Confirmation"
      icon="fa-icon-circle"
      [style]="{ width: '425px' }"
      acceptLabel="Yes"
      rejectLabel="No"
    >
    </p-confirmDialog>

    <p-dialog
      #saveDescriptionDialog
      [header]="descriptionForm?.value?.id ? 'Update Description' : 'Create Description'"
      [(visible)]="isDescriptionFormEnabled"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '650px' }"
    >
      <form
        (ngSubmit)="saveDescription(descriptionForm.value)"
        [formGroup]="descriptionForm"
        *ngIf="isDescriptionFormEnabled"
        autocomplete="off"
      >
        <div class="form-group ui-g-12">
          <div class="ui-grid-row">
            <div class="ui-g-4"><label for="description">Description</label></div>
            <div class="ui-g-8">
              <input
                class="ui-g-12"
                pInputText
                id="description"
                formControlName="description"
                tabindex="1"
              />
            </div>
            <div class="ui-g-4"><label for="xeroCode">Xero Code</label></div>
            <div class="ui-g-8">
              <input
                class="ui-g-12"
                pInputText
                id="xeroCode"
                formControlName="xeroCode"
                tabindex="2"
              />
            </div>
            <div class="ui-g-4"><label for="logic">Logic</label></div>
            <div class="ui-g-8">
              <input
                class="ui-g-12"
                pInputText
                id="logic"
                formControlName="logic"
                tabindex="3"
                autocomplete="off"
              />
            </div>
            <div class="ui-g-6">
              <p-checkbox
                class="ui-g-12"
                id="isDebit"
                formControlName="isDebit"
                tabindex="4"
                [binary]="true"
                label="Is Debit"
              ></p-checkbox>
            </div>
            <div class="ui-g-6">
              <p-checkbox
                class="ui-g-12"
                id="includeVAT"
                formControlName="includeVAT"
                tabindex="5"
                [binary]="true"
                label="Include VAT"
              ></p-checkbox>
            </div>
          </div>
          <div class="ui-grid-row" style="float: right">
            <button
              type="button"
              class="ui-button-danger"
              pButton
              icon="pi pi-times"
              label="Cancel"
              (click)="isDescriptionFormEnabled = false"
            ></button>
            <button
              type="submit"
              class="green-btn"
              pButton
              icon="pi pi-check"
              [label]="descriptionForm?.value?.id ? 'Update' : 'Add'"
              [disabled]="isSaving"
            ></button>
          </div>
        </div>
      </form>
    </p-dialog>
  </div>
</div>
